<template>
  <section class="page-container">
    <div class="">
      <housemaid-quick-quote-info
        v-if="productId == 12"
        :quoteForm="quoteForm"/>
      <!--      <working-quick-quote-info-->
      <!--        v-else-if="productId == 13"-->
      <!--        :quoteForm="quoteForm"/>-->

      <decoration-quick-quote-info
        v-else-if="productId == 15"
        :quoteForm="quoteForm"/>
      <student-quick-quote-info
        v-else-if="productId == 16"
        :quoteForm="quoteForm"/>

      <homefire-quick-quote-info
        v-else-if="productId == 17"
        :quoteForm="quoteForm"/>
      <personal-quick-quote-info
        v-else-if="productId == 18"
        :quoteForm="quoteForm"/>
      <fire-quick-quote-info
        v-else-if="productId == 20"
        :quoteForm="quoteForm"/>
      <travel-quick-quote-info
        v-else-if="productId == 14"
        :quoteForm="quoteForm"/>
      <pet-quick-quote-info
        v-else-if="productId == 22"
        :quoteForm="quoteForm"/>
      <motor-quick-quote-info
        v-else
        :quoteForm="quoteForm"/>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MotorQuickQuoteInfo from '@/views/quoting/modules/motor/quick-detail'
import HousemaidQuickQuoteInfo from '@/views/quoting/modules/housemaid/quick-detail'
import DecorationQuickQuoteInfo from '@/views/quoting/modules/decoration/quick-detail'
import HomefireQuickQuoteInfo from '@/views/quoting/modules/homefire/quick-detail'
import travelQuickQuoteInfo from '@/views/quoting/modules/travel/quick-detail'
import studentQuickQuoteInfo from '@/views/quoting/modules/student/quick-detail'
import personalQuickQuoteInfo from '@/views/quoting/modules/personal/quick-detail'
import workingQuickQuoteInfo from '@/views/quoting/modules/working/quick-detail'
import fireQuickQuoteInfo from '@/views/quoting/modules/homefire/fire-quick-detail'
import petQuickQuoteInfo from '@/views/quoting/modules/pet/quick-detail'

export default {
  name: 'Quote',
  components: {
    MotorQuickQuoteInfo,
    HousemaidQuickQuoteInfo,
    DecorationQuickQuoteInfo,
    HomefireQuickQuoteInfo,
    fireQuickQuoteInfo,
    travelQuickQuoteInfo,
    // workingQuickQuoteInfo,
    studentQuickQuoteInfo,
    personalQuickQuoteInfo,
    petQuickQuoteInfo
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    // productId: {
    //   type: Number,
    //   default: 0
    // },
    quoteForm:{
      type: Object,
      default: ()=>({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    productId(){
      return this.quoteForm.product_id
    }
  },
  watch: {

  },
  created() {

  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;

  .info-container {
    // display: flex;
    // justify-content: space-between;
    width: calc(100% - 100px);
    // .table {
    //   width: calc(50% - 10px);
    // }
  }

  .quote-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #616266;

    h2 {
      font-size: 24px;
    }

    .left {
      h2 {
        display: inline-block;
        padding-right: 10px;
      }

      span {
        font-size: 16px;
      }
    }

    .right {
      display: flex;
      align-items: center;

      span:first-child {
        display: block;
        padding-right: 10px;
        font-size: 12px;
      }

      & > div {
        margin-right: 10px;
      }
    }
  }

  .main-container {
    display: flex;
    margin-top: 10px;

    .left {
      width: 200px;
      margin-right: 15px;

      .mini {
        color: #91939a;
        font-size: 12px;
        line-height: 14px;
      }
    }

    .main-content {
      flex: 1;

      .plan-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 15px;
        border-radius: 4px;
        background: white;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        .left {
          width: 130px;
          text-align: center;

          .logo {
            display: block;
            margin-top: 10px;
            width: 120px;
            height: 64px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          margin: -15px -15px -15px 0;
          padding-left: 10px;
          width: 140px;
          background: #f4f4f5;

          .span-top {
            position: absolute;
            top: 15px;
            left: 15px;
            display: block;
            padding: 5px 10px;
            border: 1px solid #faecd8;
            border-radius: 4px;
            background: #fdf6ec;
            font-size: 12px;
            color: #e6a23c;
          }

          .amount {
            display: block;
            font-size: 24px;
            font-weight: bold;
            color: #409eff;
          }

          .unit {
            color: #616266;
            font-size: 12px;
          }

          .el-button {
            position: absolute;
            bottom: 15px;
            left: 15px;
          }
        }

        .middle {
          flex: 1;
          position: relative;
          padding-right: 15px;

          .abs-top-right {
            right: 15px;
          }

          .title {
            padding-right: 90px;
            font-size: 20px;
            color: #616266;
            font-weight: bold;
          }

          .flex {
            justify-content: space-between;

            .table {
              flex: 1;

              .table-title {
                font-size: 12px;
                font-weight: bold;
                color: #909399;
              }

              &:first-child {
                margin-right: 15px;

                .tr {
                  span:first-child {
                    width: 115px;
                  }
                }
              }

              &:last-child {
                .tr {
                  span:first-child {
                    width: 130px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
